import { forwardRef } from 'react';

import { cn } from 'src/utils/cn';

import { iconifyClasses } from './classes';

// ----------------------------------------------------------------------

export type FlagIconProps = React.HTMLAttributes<HTMLSpanElement> & {
  code?: string;
};

export const FlagIcon = forwardRef<HTMLSpanElement, FlagIconProps>(
  ({ code, className, ...other }, ref) => {
    if (!code) {
      return null;
    }

    return (
      <span
        ref={ref}
        className={cn(
          iconifyClasses.flag,
          'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-[5px] bg-muted',
          className
        )}
        style={{ width: 26, height: 20 }}
        {...other}
      >
        <img
          loading="lazy"
          alt={code}
          src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${code?.toUpperCase()}.svg`}
          className="w-full h-full max-w-none object-cover"
        />
      </span>
    );
  }
);
